export const themes = {
    ClassicLeftBound: 0,
    ClassicCentered: 1,
    Condensed: 2
}